import { useState } from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const TYPE_CONFIG = {
  info: {
    icon: CampaignOutlinedIcon,
    bg: "linear-gradient(135deg, rgba(222,168,41,0.1), rgba(247,144,114,0.1))",
    border: "rgba(222,168,41,0.25)",
    color: "#B8860B",
    iconBg: "linear-gradient(135deg, #DEA829, #F79072)",
  },
  warning: {
    icon: WarningAmberIcon,
    bg: "linear-gradient(135deg, rgba(237,108,2,0.08), rgba(255,152,0,0.08))",
    border: "rgba(237,108,2,0.25)",
    color: "#E65100",
    iconBg: "linear-gradient(135deg, #ED6C02, #FF9800)",
  },
  critical: {
    icon: ErrorOutlineIcon,
    bg: "linear-gradient(135deg, rgba(211,47,47,0.08), rgba(239,83,80,0.08))",
    border: "rgba(211,47,47,0.25)",
    color: "#C62828",
    iconBg: "linear-gradient(135deg, #D32F2F, #EF5350)",
  },
};

export default function AnnouncementBanner({ message, type = "info" }) {
  const [dismissed, setDismissed] = useState(false);
  const { palette } = useTheme();
  if (dismissed || !message) return null;

  const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.info;
  const Icon = cfg.icon;

  return (
    <Box
      sx={{
        background: cfg.bg,
        borderBottom: `1px solid ${cfg.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 1, sm: 1.5 },
        px: { xs: 1.5, sm: 3 },
        py: { xs: 0.75, sm: 1 },
        position: "relative",
        zIndex: 1200,
      }}
    >
      <Box
        sx={{
          width: { xs: 24, sm: 28 },
          height: { xs: 24, sm: 28 },
          borderRadius: "50%",
          background: cfg.iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: { xs: 14, sm: 16 }, color: "#FFFFFF" }} />
      </Box>

      <Typography
        sx={{
          fontSize: { xs: "0.78rem", sm: "0.85rem" },
          fontWeight: 600,
          color: cfg.color,
          flex: 1,
          textAlign: "center",
        }}
      >
        {message}
      </Typography>

      <IconButton
        size="small"
        onClick={() => setDismissed(true)}
        sx={{
          color: cfg.color,
          opacity: 0.6,
          "&:hover": { opacity: 1, backgroundColor: "transparent" },
        }}
      >
        <CloseIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />
      </IconButton>
    </Box>
  );
}
